import { GenericLabel } from '@com-delta-idp/mnx-utils';
import { Link } from '../../atoms/link/models/link.interfaces';

/**
 * This Types are based on the Form elements and the Input types.
 *  To get more detail you can check:
 *  https://www.w3schools.com/html/html_form_elements.asp
 *  https://www.w3schools.com/html/html_form_input_types.asp
 */
export type ControlType =
  | 'button'
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'dropdown'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'submit'
  | 'tel'
  | 'text'
  | 'text-options' // Based on Datalist https://www.w3schools.com/tags/tag_datalist.asp
  | 'textarea'
  | 'time'
  | 'url'
  | 'week'
  | 'component'
  | 'text-focusout';

export interface CallToAction {
  input: ControlType;
  link: Link;
  message?: GenericLabel;
  enable?: boolean;
}
